import css from 'styled-jsx/css'
import { colors } from 'theme'

export default css`
  .container-portals {
    display: flex;
    margin: 0 auto;
    justify-content: center;
  }

  .wrapper-btn-download .message {
    display: none;
  }
  .wrapper-btn-download .btn-download-audio {
    color: ${colors.text};
  }

  .wrapper-table-to-card {
    width: 100%;
    margin-top: 2rem;
  }

  @media screen and (max-width: 992px) {
    .wrapper-btn-download .message {
      display: initial;
    }
    .wrapper-btn-download :global(.btn-download-audio) {
      display: none;
      border: 1px solid red;
    }
  }
`
